<!-- 考勤统计 -->
<template>
    <div class="fuzzy-matching-box">
     <div class="Tongji-center" v-if="titleValue == '考勤统计'">
      <div class="fuzzy-matching-top">
        <el-row class="top-first-line the-second-line">
          <el-col :span="5">
            <el-form-item label="时间:">
              <el-date-picker
                  v-model="Dform.startTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col >
          <el-button type="primary" size="medium" class="query-button" @click="inquiryClick">查询</el-button>
            <el-col :span="5">
          </el-col >
            <el-col :span="5">
            </el-col >
            <el-col :span="5">
            </el-col >
        </el-row>
      </div>
      <div class="fuzzy-matching-bottom">
        <el-row class="list">
           <el-table
              stripe
              :border="true"
              :header-cell-style="{background:'#EDF6FF',color:'#000',}"
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange">
            <el-table-column
              prop="name"
              label="学校"
              >
            </el-table-column>
            <el-table-column
              prop="enter"
              label="刷卡（到校）"
              >
            </el-table-column>
            <el-table-column
            prop="enterNoSwipingCard"
            label='未刷卡（到校）'
            >
            </el-table-column>
            <el-table-column
            show-overflow-tooltip
              prop="leave"
              label="刷卡（离校）"
              >
            </el-table-column>
            <el-table-column
            show-overflow-tooltip
              prop="leaveNoSwipingCard"
              label="未刷卡（离校）"
              >
            </el-table-column> 
            <el-table-column
            show-overflow-tooltip
              prop="exceptionSwipingCard"
              label="异常刷卡"
              >
            </el-table-column> 
            <el-table-column
            show-overflow-tooltip
              prop="total"
              label="总数"
              >
            </el-table-column> 
            <el-table-column
            show-overflow-tooltip
              label="操作"
              >
              <template #default="scope">
                            <el-button type="text"  class="lookClass" size="small" v-if="scope.row.schoolId != ''" @click="LookGraderClick(scope.row)">查看年级考勤</el-button>
                            <el-button type="text"  class="lookClass" size="small" v-else @click="LookClassClick(scope.row)">查看班级考勤</el-button>
               </template>
            </el-table-column> 
          </el-table>
  
          <div class="block-fenye" >
            <el-pagination
                :small="small"
                :disabled="disabled"
                :background="background"
                layout="prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
          </div>
        </el-row>
      </div>
     </div>
      <Graderadd 
        v-if="titleValue == '查看年级考勤'" 
        :graderOBJ="graderOBJ"  
         @nianjifanhui="nianjifanhui"
         @chakanbanji="chakanbanji"
         :quanxian="quanxian"
         ></Graderadd>
      <Classadd 
      v-if="titleValue == '查看班级考勤'" 
      :ClassObj="ClassObj"
      :quanxian="quanxian"
      @banjifanhui="banjifanhui"></Classadd>
    </div>
  </template>
  
  <script>
  import {schoolListTongji,} from '@/assets/api/schoollog';
  import {findTeacherInfo} from '@/assets/api/renyuan';
  import Graderadd from './LookGrader/Graderadd.vue'
  import Classadd from './LookClass/ClassAdd.vue'

  export default {
    components: {
      Graderadd,
      Classadd
    },
    data() {
        return {
          
          loading:true,
          Dform:{
            startTime:'',
            endTime:'',
            gradeId:'',
            schoolId:'',
            userId:'',
          },
          tableData: [],
          pageInfo: {
            page: 1,
            pageSize: 10,
          },
          total: 0,
          titleValue:'考勤统计',
          graderOBJ:{},
          ClassObj:{},
          quanxian: {},
        };
    },
    created() {
      // this.attendanceDeleteTongJiClick()
      this.LookTeacher()
      
    },
    mounted() {
  
    },
    methods: {
      //查看老师权限
      LookTeacher(){
        const params = {
          userId:JSON.parse(localStorage.getItem('user')).id,
        }
        findTeacherInfo(params).then((res)=>{
          this.quanxian = res.data.data
          console.log(this.quanxian.schoolId,'查看老师权限');
          if (res.data.data.classId != null) {
            console.log('老师');
            this.titleValue = '查看班级考勤'
          }else if(res.data.data.gradeId != null){
            console.log('年级');
            this.titleValue = '查看年级考勤'
          }else if(res.data.data.schoolId != null){
            console.log('学校');
            this.titleValue = '考勤统计'
            const Dparams ={
              userId:JSON.parse(localStorage.getItem('user')).id,
              page: this.pageInfo.page,
              pageSize: this.pageInfo.pageSize,
              startTime: this.Dform.startTime,
              endTime: this.Dform.endTime,
              schoolId:res.data.data.schoolId
      }
            this.attendanceDeleteTongJiClick(Dparams)
          }else{
            console.log('集团');
            this.titleValue = '考勤统计'
              let Dparams = {
                userId:JSON.parse(localStorage.getItem('user')).id,
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
                startTime: this.Dform.startTime,
                endTime: this.Dform.endTime,
                schoolId:res.data.data.schoolId
              }
            this.attendanceDeleteTongJiClick(Dparams)
          }

        }).catch((err)=>{
          console.log(err);
        })
      },
           //查看班级考勤
      LookClassClick(item){
        this.titleValue = '查看班级考勤'
        this.ClassObj = item
      },
      chakanbanji (item) {
        this.titleValue = '查看班级考勤'
        this.ClassObj = item
      },  
      backClick(){ 
        this.titleValue = '查看年级考勤'
      },
      nianjifanhui(){ // 年级返回
        this.titleValue = '考勤统计'
      },
      banjifanhui(){ // 班级返回
        this.titleValue = '查看年级考勤'
      },
      //查看年级考勤
      LookGraderClick(item){
        console.log(item,'查看年级考勤');
        this.graderOBJ = item
        this.titleValue = '查看年级考勤'
      },
        //查询
      inquiryClick( ) {
        this.pageInfo.page = 1
        this.total = 0
        const Dparams ={
              userId:JSON.parse(localStorage.getItem('user')).id,
              page: this.pageInfo.page,
              pageSize: this.pageInfo.pageSize,
              startTime: this.Dform.startTime,
              endTime: this.Dform.endTime,
              schoolId:this.quanxian.schoolId
      }
        
        this.attendanceDeleteTongJiClick(Dparams)
      },
      // 列表
     attendanceDeleteTongJiClick (params) {
        schoolListTongji(params).then((res)=> {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.loading = false
          console.log(res,'考勤统计--接口');
        }).catch((err)=> {
            console.log(err);
        })
      },
      handleCurrentChange (val) {
        this.pageInfo.page = val
        this.attendanceDeleteTongJiClick()  
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
    .fuzzy-matching-box {
      padding-top: 35px;
      // overflow: hidden;
      // overflow: auto;
      width: 100%;
      height:  96%;
      background-color: #fff;
      border-radius: 8px;
      .Tongji-center{
        height: 100%;
      }
      .title-top {
          // padding:  20px;
      }
      .fuzzy-matching-top {
      height: 60px ;
      background-color: #fff;
      border-radius: 8px;
      .top-first-line {
        // justify-content: center 
        // justify-content: space-between
        justify-content: space-around;
        :deep() {
          .el-form-item--small .el-form-item__label {
            // background-color: red;
            font-size: 16px;
          }
    
          .el-form-item--small .el-form-item__label {
            width: 110px;
            text-align: right;
            height: 35px;
            line-height: 35px;          
          }
          .el-input {
            width: 100%;
            height: 35px;
          }
          .query-button{
            margin: 0;
            }
        }
      }
     
    }
    .fuzzy-matching-bottom {
      height: calc(100% - 170px);
      // overflow: auto;
      // position: relative;
      padding: 0px 20px;
      padding-top: 10px;
      margin-top: 15px;
      background-color: #fff;
      border-radius: 8px;
      .lookClass{
        font-size: 15px;
      font-weight: 700;
      } 
      
      .top-first-line {
        height: 45px;
        line-height: 45px;
          :deep(.tip-button) {
            padding: 14px 14px;
            margin: 0px 3px;
          }
        .import-export-button {
          position: absolute;
          right: 20px;
          :deep(.el-button--small) {
            padding: 16px 24px;
            border: 1px solid #569CFF;
            color: #569CFF;
          }
        }
      }
      .list {
        position: relative;
        // margin-top: 10px;
        padding-bottom: 50px;
       .fenye {
        // float: right;
        text-align: center;
       }
        :deep() {
          .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
            // border: 0px;
          }
          .el-table tr {
            height: 40px;
            cursor: pointer;
            // user-select: none;
            font-size: 16px;
            color: black;
          }
           .manipulate {
            color: red;
            margin-right:15px;
            // cursor: pointer;
            // user-select: none;
          }
          .confirm,.duplicate,.revise {
            color:#1677FF;
            
          }
          .el-table th.el-table__cell>.cell {
            text-align: center;
            font-size: 16px;
            font-weight: 700;
          }
          .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
            text-align: center;
          }
        }
        .block-fenye {
          // float: right;
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translate(-50%,0);
          
        }
      }
    }
  }
  </style>
  